import { FC } from 'react';
import { NotFoundPageContent } from '@frontend/digital-forms-ui';

export const NotFoundPage: FC = () => {
  return <NotFoundPageContent />;
};
